module.exports = __webpack_public_path__ + "img/nav-chat-active.6d7131f1.svg";